import { styled, Box } from '@mui/material';

export const StyledFlexAllCenter = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledFlexTopCenter = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StyledFlexTopBaseline = styled(Box)`
  display: flex;
  align-items: baseline;
`;

export const StyledFlexTopStart = styled(Box)`
  display: flex;
  align-items: flex-start;
`;

export const StyledFlexWrap = styled(Box)`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledFlexColumn = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const StyledFlexSpaceBetween = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const StyledFlexEnd = styled(Box)`
  display: flex;
  justify-content: flex-end;
`;
